import { createSlice } from "@reduxjs/toolkit";
import verifyEmailApi from "../../../rtk-apis/authentication/verifyEmail";

const initialState = {
    status: "",
    result: {},
    msg: "",
    loading: false,
    error: "",
};

const verifyEmailSlice = createSlice({
    name: "verifyEmailSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(verifyEmailApi.pending, (state) => {
                state.loading = true;
            })
            .addCase(verifyEmailApi.fulfilled, (state, { payload }) => {
                console.log('payload', payload)
                state.loading = false;
                state.status = payload.status;
                state.result = payload.result;
                state.msg = payload.msg;
            })
            .addCase(verifyEmailApi.rejected, (state, { payload }) => {
                state.result = payload;
                state.loading = false;
            });
    },
});

export default verifyEmailSlice.reducer;
